// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import "./styles/tailwind.css";
// import "./styles/custom.css";
// import { BrowserRouter } from "react-router-dom";
// import { HelmetProvider } from "react-helmet-async";
// // import reportWebVitals from "./reportWebVitals";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(

//   <React.StrictMode>
//     <HelmetProvider>
//       <BrowserRouter basename="/">
//         <App />
//       </BrowserRouter>
//     </HelmetProvider>
//   </React.StrictMode>
// );



import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client"; // Added hydrateRoot
import "./index.css";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/custom.css";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");

// Define your app structure to keep code clean
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Conditional logic for Hydration
if (container.hasChildNodes()) {
  // Prerendered HTML detected: Hydrate it
  hydrateRoot(container, app);
} else {
  // No HTML: Standard render
  const root = createRoot(container);
  root.render(app);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
